import React, { Suspense } from "react";
import DetailSection from "../../../components/DetailSection";
import { SmartRenderer } from "../ components/SmartRenderer";
import { Typography } from "@material-ui/core";
// Import import AuditLogs from "../../../components/AuditLogs"; dynamic import
const AuditLogs = React.lazy(() => import("../../../components/AuditLogs"));

export const GenericVerification = ({ verification }) => {
  const stepsData = verification?.steps?.length
    ? verification.steps.reduce((acc, step) => {
        acc[step.name] = step.data;
        return acc;
      }, {})
    : {};

  return (
    <>
      {typeof verification.data === "object" &&
      Object.keys(verification.data).length ? (
        <div className="max-w-[980px] p-8 bg-white">
          <SmartRenderer data={verification.data} />
        </div>
      ) : null}

      {Object.keys(stepsData).length ? (
        <div className="max-w-[980px] p-8 bg-white">
          <Typography variant="h6">Steps</Typography>
          <SmartRenderer data={stepsData} />
        </div>
      ) : null}
      <DetailSection title="Audit Logs">
        <Suspense fallback={<div>Loading...</div>}>
          <AuditLogs
            auditableId={verification.id}
            auditableType="BoomScreen::Verification"
          />
        </Suspense>
      </DetailSection>
    </>
  );
};
